import { DOCUMENT_TYPES } from 'src/constants/documentTypes';
import getDefaultTextLang from 'src/context/Language/getDefaultTextLang';
import { ITextKeys as ITextLangKeys } from 'src/context/Language/types';

const OLD_DOCUMENT_TYPE_LABELS: Record<string, ITextLangKeys> = {
  paystub: 'dup_document_type_paystub',
  bank_statement: 'dup_document_type_bank_statement'
};

export const getOldDocumentTypes = (translate?: (key: ITextLangKeys) => string) => {
  const t = !translate ? getDefaultTextLang : translate;
  return DOCUMENT_TYPES.filter((type) => type.key in OLD_DOCUMENT_TYPE_LABELS).map((type) => ({
    key: type.key,
    value: type.value,
    label: t(OLD_DOCUMENT_TYPE_LABELS[type.key]),
    defaultValue: 2
  }));
};
